module.exports = __webpack_public_path__ + "img/16581263_L.2ad6862e.png";